// extracted by mini-css-extract-plugin
export var projectsContainer = "projects-module--projects-container--398Ae";
export var metadataList = "projects-module--metadata-list--3XhoC";
export var projectLogo = "projects-module--project-logo--3Qabs";